import React, { useRef, useState } from 'react'
import { TextInput, CustomButton } from './FormInputs'
import { Row, Col, Button } from 'reactstrap'
import useAuth from '../../hooks/useAuth';
import useFormvalidation from '../../hooks/validations/useFormvalidation';
import validate from '../../hooks/validations/FormValidationRules';


function ChangePasswordModal({ closeModal }) {
  const { changePassword } = useAuth();
  const submitLockRef = useRef(false);

  const [formValues, setFormValues] = useState({
    old_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // const handleNext = () => {
  //   if (formValues.new_password !== formValues.confirm_password) {
  //     alert("New password and confirm password do not match!");
  //     return;
  //   }

  //   const payload = {
  //     oldPassword: values.old_password,
  //     newPassword: values.new_password,
  //     confirmPassword: values.confirm_password,
  //   };

  //   pwd_update.mutate(payload);
  // };

const handleNext = () => {
  if (submitLockRef.current) return;

  submitLockRef.current = true;
  setIsSubmitting(true);

  setErrors({});

  if (values.new_password !== values.confirm_password) {
    setErrors({ confirm_password: "Passwords do not match" });
    submitLockRef.current = false;
    setIsSubmitting(false);
    return;
  }

  const payload = {
    oldPassword: values.old_password,
    newPassword: values.new_password,
    confirmPassword: values.confirm_password,
  };

  pwd_update.mutate(payload, {
    onSuccess: (res) => {
      // 🔥 THIS WILL NOW WORK
      if (!res?.success) {
        setErrors({
          old_password: res.message || "Old password is incorrect"
        });
      } else {
        setErrors({});

        setFormValues({
          old_password: "",
          new_password: "",
          confirm_password: ""
        });

        // ✅ toast
        // import('react-toastify').then(({ toast }) => {
        //   toast("Password changed successfully");
        // });
      }

      submitLockRef.current = false;
      setIsSubmitting(false);
    },

    onError: (err) => {
      // fallback (network error)
      setErrors({
        old_password:
          err?.response?.message || "Password Incorrect"
      });

      submitLockRef.current = false;
      setIsSubmitting(false);
    }
  });
};

const handleButtonClick = () => {
  if (submitLockRef.current) return;

  const validationErrors = validate(values);
  setErrors(validationErrors);

  if (Object.keys(validationErrors).length > 0) {
    return;
  }

  handleNext();
};

  const { handleChange, errors, setErrors, values } = useFormvalidation(
    handleNext,
    validate,
    formValues,
    setFormValues
  );
  const pwd_update = changePassword(setErrors)

  return (
    <Row>
      <Col lg={12}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0" style={{ color: '#003049' }}>Change Password</h5>
          <i
            className="ri-close-line"
            style={{ fontSize: '24px', cursor: 'pointer', color: '#003049' }}
            title="Close"
            onClick={closeModal}
          ></i>
        </div>

        {/* <TextInput
          input_type={2}
          name="old_password"
          isrequired
          label="Old Password"
          placeholder="Enter old password"
          value={values.old_password}
          onChange={handleChange}
          invalid={errors.old_password ? true : false}
          error_msg={errors.old_password}
        /> */}
        <TextInput
  input_type={2}
  name="old_password"
  isrequired
  label="Old Password"
  placeholder="Enter old password"
  value={values.old_password}
onChange={(e) => {
  handleChange(e);

  // ✅ clear old password error when user types again
  if (errors.old_password) {
    setErrors((prev) => ({
      ...prev,
      old_password: ""
    }));
  }
}}
  invalid={errors.old_password ? true : false}
  error_msg={errors.old_password}
/>

        <TextInput
          input_type={2}
          name="new_password"
          // type="password"
          isrequired
          label="New Password"
          placeholder="Enter new password"
          value={values.new_password}
          onChange={handleChange}
          invalid={errors.new_password ? true : false}
          error_msg={errors.new_password}
        />

        <TextInput
          input_type={2}
          name="confirm_password"
          // type="password"
          isrequired
          label="Confirm Password"
          placeholder="Re-enter new password"
          value={values.confirm_password}
          onChange={handleChange}
          invalid={errors.confirm_password ? true : false}
          error_msg={errors.confirm_password}
        />

        {/* <div className="d-flex justify-content-center"> */}
          {/* <CustomButton handleSubmit={handleSubmit} label="Submit" /> */}
          <div className="d-flex justify-content-center">
  <button
    type="button"
    className="btn btn-primary"
    onClick={handleButtonClick}
    disabled={isSubmitting}
  >
    {isSubmitting ? "Submitting..." : "Submit"}
  </button>
</div>
        {/* </div> */}
      </Col>
    </Row>
  );
}

export default ChangePasswordModal;



























